import { Button, Card, Placeholder, Row, Spinner, Table } from "react-bootstrap";
import { format } from "date-fns";

export function HistoryBatches({
  batches,
  loading,
  exportingBatchId,
  handleExportBatchDetails
}) {
  return (
    <>
      {(batches.length > 0 && !loading.isLoading) && (
        <>
          <Card.Subtitle className="mb-2 text-muted">
            Lotes de Importação
          </Card.Subtitle>

          <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
            <Table bordered hover>
              <thead>
                <tr className="z-n1">
                  <th>Lote</th>
                  <th>Usuário</th>
                  <th>Data</th>
                  <th>Processados</th>
                  <th>Não Processados</th>
                  <th>Situação</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {batches.map((batch) => (
                  <tr key={batch.idlote}>
                    <td>{batch.idlote}</td>
                    <td>{batch.usuario}</td>
                    <td>{format(new Date(batch.dtageracao), 'dd/MM/yyyy hh:mm:ss')}</td>
                    <td>{batch.processado}</td>
                    <td>{batch.nprocessado}</td>
                    <td>{batch.situacao}</td>
                    <td>
                      <Row className="justify-content-center">
                        <Button
                          type="button"
                          variant="info"
                          size="sm"
                          disabled={exportingBatchId !== null}
                          onClick={() => handleExportBatchDetails(batch.idlote)}
                        >
                          {exportingBatchId === batch.idlote ? (
                            <>
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                className="me-2"
                              /> {" "}
                              Exportando...
                            </>
                          ) : (
                            <>
                              <i className="fa fa-file-export mr-2" />
                              Exportar
                            </>
                          )}
                        </Button>
                      </Row>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}

      {(loading.isLoading) && (
        <>
          <Card.Subtitle className="mb-2 text-muted">
            <Placeholder as="span" animation="glow">
              <Placeholder xs={4} />
            </Placeholder>
          </Card.Subtitle>

          <Table bordered hover>
            <thead>
              <tr>
                <th>
                  <Placeholder as="span" animation="glow">
                    <Placeholder xs={4} />
                  </Placeholder>
                </th>
                <th>
                  <Placeholder as="span" animation="glow">
                    <Placeholder xs={4} />
                  </Placeholder>
                </th>
                <th>
                  <Placeholder as="span" animation="glow">
                    <Placeholder xs={4} />
                  </Placeholder>
                </th>
                <th>
                  <Placeholder as="span" animation="glow">
                    <Placeholder xs={4} />
                  </Placeholder>
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 3 }).map((_, index) => (
                <tr key={index}>
                  <td>
                    <Placeholder as="span" animation="glow">
                      <Placeholder xs={4} />
                    </Placeholder>
                  </td>
                  <td>
                    <Placeholder as="span" animation="glow">
                      <Placeholder xs={8} />
                    </Placeholder>
                  </td>
                  <td>
                    <Placeholder as="span" animation="glow">
                      <Placeholder xs={6} />
                    </Placeholder>
                  </td>
                  <td>
                    <Placeholder as="span" animation="glow">
                      <Placeholder xs={4} />
                    </Placeholder>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table></>
      )}
    </>
  )
}
